import { render, staticRenderFns } from "./SaleInvoicesRetentionTable.vue?vue&type=template&id=537f70c1&scoped=true&"
import script from "./SaleInvoicesRetentionTable.vue?vue&type=script&lang=js&"
export * from "./SaleInvoicesRetentionTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "537f70c1",
  null
  
)

export default component.exports